<app-modal-header [automaticClose]="false" (closeEvent)="onCloseModal()" class="border-b-2 border-theme-500">
  <div class="flex items-center">
    <svg-icon class="hidden w-24 md:block" src="assets/images/logos/logo-eclass.svg"></svg-icon>
    <hr app-modal-divider class="hidden md:block" />
    <h1 translate class="text-lg text-gray-500" translate>eclass.trilhas-aula</h1>
  </div>
</app-modal-header>
<div app-modal-content class="h-[80vh] w-[95vw] rounded-b-3xl! p-0! pb-5!">
  <app-sidenav-group>
    <ng-template
      app-sidenav-start
      [opened]="multipleElements ? true : false"
      [closedAnchor]="!multipleElements ? true : false"
      bgColor="bg-white rounded-bl-3xl !shadow-inner-horizontal !px-5"
    >
      <div class="flex w-11/12 flex-col gap-2 p-3 md:w-full">
        @for (element of data.trailElements; track element) {
          <div
            (click)="setContent(element)"
            class="w-12/12 flex cursor-pointer items-center justify-between rounded-xl bg-white p-3 shadow shadow-black/40"
            [ngClass]="{ 'bg-gray-300!': isSelected(element.id) }"
          >
            <div class="w-2/12">
              <svg-icon
                class="flex w-6"
                [ngClass]="getStyleTextIcon(element.tipo)"
                [src]="'assets/icons/' + mapTypeToIcon(element.tipo)"
              >
              </svg-icon>
            </div>
            <div class="flex w-9/12 flex-col items-start justify-start">
              <p class="text-md">{{ element.titulo }}</p>
            </div>
            <div class="mr-2 flex w-1/12 justify-center p-2">
              @if (element.completed) {
                <svg-icon
                  class="flex h-5 w-5 rounded-full bg-green-500 p-1 text-white"
                  src="assets/icons/icon-check.svg"
                ></svg-icon>
              }
            </div>
          </div>
        }
      </div>
    </ng-template>
    <ng-template app-sidenav-outer>
      <div [ngClass]="{ 'pl-14': !multipleElements }" class="flex min-h-full flex-col bg-base-whisper-500 p-8">
        <div class="flex flex-col items-start justify-center gap-2 pb-4">
          <div class="flex items-center justify-start gap-2">
            <svg-icon
              class="flex w-6"
              [ngClass]="getStyleTextIcon(currentElement.tipo)"
              [src]="'assets/icons/' + mapTypeToIcon(currentElement.tipo)"
            ></svg-icon>

            <div class="pl-2 text-2xl">{{ currentElement.titulo }}</div>
            <div class="ml-2 text-md text-theme-900">
              {{ currentElement.titulo }}
            </div>
          </div>
        </div>
        @if (elementData$ | async; as elementData) {
          @if (currentElement.titulo !== undefined) {
            <div class="flex h-full flex-col items-center justify-center">
              @switch (currentElement.tipo) {
                @case ('video') {
                  <app-video-card [element]="elementData" [fullWidth]="true"></app-video-card>
                }
                @case ('audio') {
                  <app-audio-card
                    [element]="elementData"
                    [fullWidth]="true"
                    [paddingBottom]="!multipleElements"
                  ></app-audio-card>
                }
                @case ('imagem') {
                  <app-image-card [element]="elementData" [fullWidth]="true"></app-image-card>
                }
                @case ('link') {
                  <app-link-card
                    [element]="elementData"
                    [fullWidth]="true"
                    [paddingBottom]="!multipleElements"
                  ></app-link-card>
                }
                @case ('avaliacao') {
                  <app-test-card
                    [elementInfo]="currentElement"
                    [element]="elementData"
                    [fullWidth]="true"
                    [dailyId]="data.dailyId"
                    [paddingBottom]="!multipleElements"
                  ></app-test-card>
                }
                @case ('flip') {
                  <app-flip-card [element]="elementData" [fullWidth]="true"></app-flip-card>
                }
              }
            </div>
          } @else {
            <div app-card-content class="h-full p-5">
              <app-jumbotron translate class="py-8">eclass.importar-trilhas.sem-elementos</app-jumbotron>
            </div>
          }

          @if (multipleElements) {
            <div
              class="rounded-b-2xl bg-white p-10 shadow-xl"
              [ngClass]="{ 'rounded-t-2xl': elementData.tipo === 'texto' }"
            >
              @if (!!elementData.conteudo) {
                <div class="mb-10" [innerHTML]="elementData.conteudo"></div>
              }
              <div
                class="mb-2 flex w-full flex-col gap-5 md:flex-row"
                [ngClass]="{
                  'justify-between': !isFirst && !isLast,
                  'justify-start': isLast,
                  'justify-end': isFirst,
                }"
              >
                @if (!isFirst) {
                  @if (getPreviousElement(); as previousElement) {
                    <button
                      (click)="goToPrevious(); (setContent)"
                      type="button"
                      app-icon-button
                      class="group mx-2 mb-5 flex justify-between border border-theme-500 shadow shadow-black/40 hover:bg-theme-500 hover:text-theme-50 lg:mb-0"
                    >
                      <svg-icon
                        class="mr-2 flex h-6 w-6 justify-center text-theme-500 group-hover:text-theme-contrast"
                        src="assets/icons/icon-arrow-left-fine.svg"
                      ></svg-icon>
                      <div translate>
                        trilhas.anterior <span>{{ previousElement.titulo }}</span>
                      </div>
                      <svg-icon
                        class="ml-2 flex h-6 w-6 justify-center group-hover:text-theme-contrast"
                        [ngClass]="getStyleTextIcon(previousElement.tipo)"
                        [src]="'assets/icons/' + mapTypeToIcon(previousElement.tipo)"
                      ></svg-icon>
                    </button>
                  }
                }
                @if (!isLast) {
                  @if (getNextElement(); as nextElement) {
                    <button
                      (click)="goToNext(); (setContent)"
                      type="button"
                      app-icon-button
                      class="group mx-2 flex justify-between border border-theme-500 shadow shadow-black/40 hover:bg-theme-500 hover:text-theme-50"
                    >
                      <svg-icon
                        class="mr-2 flex h-6 w-6 justify-center group-hover:text-theme-contrast"
                        [ngClass]="getStyleTextIcon(nextElement.tipo)"
                        [src]="'assets/icons/' + mapTypeToIcon(nextElement.tipo)"
                      ></svg-icon>
                      <div translate>
                        trilhas.proximo <span>{{ nextElement.titulo }}</span>
                      </div>
                      <svg-icon
                        class="ml-2 flex h-6 w-6 justify-center text-theme-500 group-hover:text-theme-contrast"
                        src="assets/icons/icon-arrow-right-fine.svg"
                      ></svg-icon>
                    </button>
                  }
                }
              </div>
            </div>
          }
          @if (elementData.anexos?.length > 0) {
            <div class="mt-4 rounded-2xl bg-white p-10 shadow-xl">
              <div class="flex items-center justify-between">
                <div class="text-lg text-theme-900">Anexos</div>
              </div>
              @for (annex of elementData.anexos; track annex) {
                <div
                  class="mt-4 flex cursor-pointer items-center justify-between gap-2 overflow-y-auto rounded-lg bg-[#fcfcfc] p-2 shadow-md"
                >
                  <div class="h-16 w-16 rounded-full p-4 shadow-inner">
                    <svg-icon [src]="'/assets/images/files/' + annex.extensao + '.svg'"> </svg-icon>
                  </div>
                  <div class="ml-5 flex w-full flex-col items-start justify-start py-2 lg:ml-0 lg:py-0">
                    <p class="wrap-break-word text-base font-semibold">
                      {{ annex.nome_arquivo }}
                    </p>
                    <p class="text-theme-400">{{ annex.extensao }}</p>
                  </div>
                  <button type="button" app-icon-button (click)="onOpenAnnex(annex)" class="mx-2 flex justify-between">
                    <svg-icon
                      class="w-6 text-theme-500 hover:text-theme-700"
                      src="assets/icons/icon-view.svg"
                    ></svg-icon>
                  </button>
                </div>
              }
            </div>
          }
        }
      </div>
    </ng-template>
  </app-sidenav-group>
</div>
